import { SampleGroupExtended } from "../pharma/services";
import { isAnyTaskEndState } from "src/app/tasks/util/is-any-task-end-state";

export const hasEndStateTasks = (sampleGroup: SampleGroupExtended) => {
    const taskInstances = sampleGroup.TaskInstance?.MemberTaskInstance ?? [];
    return isAnyTaskEndState(taskInstances) || (sampleGroup.HasEndStateMemberTask ?? false);
}